import { useQuery } from '@tanstack/react-query';
import { apiClient } from '@/auth/apiClient';
import { queryKeys } from './queryKeys';
import type { PlanDiff, UUID } from './types';

export function useVergleich(planA: UUID | null, planB: UUID | null) {
  const enabled = !!planA && !!planB && planA !== planB;
  return useQuery({
    queryKey: enabled ? queryKeys.vergleich.diff(planA, planB) : ['vergleich', 'none'],
    queryFn: async (): Promise<PlanDiff> => {
      if (!planA || !planB) throw new Error('beide Pläne erforderlich');
      const res = await apiClient.get<PlanDiff>('/vergleich', {
        params: { a: planA, b: planB },
      });
      return res.data;
    },
    enabled,
  });
}
